import axiosClient from "../axiosClient";

export const reportCsvDownload = async (data) => {
  return await axiosClient.post("/subscription_report", data);
};

export const freeSubscriptionReport = async (data) => {
  return await axiosClient.post("/free_subscription_report", data);
};

export const paidSubscriptionReport = async (data) => {
  return await axiosClient.post("/paid_subscription_report", data);
};

export const coursePurchasedReport = async (data) => {
  return await axiosClient.post("/course_purchased_report", data);
};

export const cancelSubscriptionReport = async (data) => {
  return await axiosClient.post("/cancel_subscription_report", data);
};

export const completedCourseReport = async (data) => {
  return await axiosClient.post("/course_completed_report", data);
};

export const popularCourseReport = async (data) => {
  return await axiosClient.post("/popular_course_report", data);
};

export const individualCourseReport = async (data) => {
  return await axiosClient.post("/individual_course_report", data);
};

export const usersReport = async (data) => {
  return await axiosClient.post("/users_report", data);
};

export const freeClassReport = async (data) => {
  return await axiosClient.post("/freeclass_signups_report", data);
};

export const preclgApplicationSubmitted = async (data) => {
  return await axiosClient.post("/preclg_application_submitted_report", data);
};

export const preclgTotalEnrollments = async (data) => {
  return await axiosClient.post("/preclg_total_enrollment", data);
};

export const preclgTotalCompletion = async (data) => {
  return await axiosClient.post("/preclg_total_completion", data);
};

export const preclgStudentPregressOverview = async (data) => {
  return await axiosClient.post("/preclg_student_progress_overview", data);
};

export const preclgCourseEnrollment = async (data) => {
  return await axiosClient.post("/preclg_course_enrollment", data);
};

export const salesCoursePurchase = async (data) => {
  return await axiosClient.post("/preclg_course_purchase", data);
};

export const salesPaymentPending = async (data) => {
  return await axiosClient.post("/preclg_payment_pending", data);
};

export const salesOverview = async (data) =>{
  return await axiosClient.post("/preclg_overview",data)
}

export const salesAppPurchase = async (data) =>{
  return await axiosClient.post("/preclg_app_purchase",data)
}

export const salesAppPurchaseCert = async (data) =>{
  return await axiosClient.post("/cert_app_purchase",data)
}
// certificate  reports

export const certApplicationSubmitted = async (data) => {
  return await axiosClient.post("/certApplicationReport", data);
};

export const CertTotalEnrollments = async (data) => {
  return await axiosClient.post("/CertEnrollment", data);
};


export const CertTotalCompletion = async (data) => {
  return await axiosClient.post("/certCompletion", data);
};
export const  certStudentPregressOverview = async (data) => {
  return await axiosClient.post("/cert_student_progress_overview", data);
};

export const certCourseEnrollment = async (data) => {
  return await axiosClient.post("/cert_course_enrollment ", data);
};


export const certsalesCoursePurchase = async (data) => {
  return await axiosClient.post("/cert_course_purchase", data);
};

export const certsalesPaymentPending = async (data) => {
  return await axiosClient.post("/cert_payment_pending", data);
};

export const certsalesOverview = async (data) =>{
  return await axiosClient.post("/cert_overview",data)
}

// Dl program

export const dlApplicationSubmitted = async (data) => {
  return await axiosClient.post("/dlApplicationReport", data);
};

export const DlTotalEnrollments = async (data) => {
  return await axiosClient.post("/DlEnrollment", data);
};

export const DlTotalCompletion = async (data) => {
  return await axiosClient.post("/dlCompletion", data);
};

export const  DlStudentPregressOverview = async (data) => {
  return await axiosClient.post("/dl_student_progress_overview", data);
};

export const DlCourseEnrollment = async (data) => {
  return await axiosClient.post("/dl_course_enrollment ", data);
};